<template></template>

<script>
import anime from 'animejs';

export default {
    name: 'hero',

    mounted() {
        if (this.$refs.bg) {
            anime({
                targets: this.$refs.bg,
                scaleX: [1, 0],
                duration: 600,
                delay: 200,
                easing: 'easeOutQuad',
            });
        }

        const timeline = anime.timeline({
            easing: 'easeOutQuad',
        });

        timeline
            .add(
                {
                    targets: this.$refs.content.children,
                    opacity: [0, 1],
                    translateY: ['30px', 0],
                    duration: 400,
                    delay: anime.stagger(600),
                },
                400,
            )
            .add(
                {
                    targets: this.$refs.cta,
                    opacity: [0, 1],
                    duration: 400,
                    translateY: ['30px', 0],
                    delay: anime.stagger(600),
                },
                400,
            )
            .add({
                targets: this.$refs.button,
                opacity: [0, 1],
                translateY: ['15px', 0],
                duration: 400,
            });
    },

    computed: {
        isTouchDevice() {
            return 'ontouchstart' in document.documentElement;
        },
    },
};
</script>
